import { LocaleType } from '@/pages/opinion/types/common';
import type { FilterKeys, PlaceholderType } from '../types';
import { getLocale } from 'umi';

export const engagementPerformancePlaceholder: PlaceholderType = {
  'en-US': 'Engagement Performance',
  'zh-CN': '指标表现',
};

export const engagementsPlaceholder: PlaceholderType = {
  'en-US': 'Engagement',
  'zh-CN': '互动量',
};

export const commentsPlaceholder: PlaceholderType = {
  'en-US': 'Comment',
  'zh-CN': '评论量',
};

export const likesPlaceholder: PlaceholderType = {
  'en-US': 'Like',
  'zh-CN': '点赞量',
};

export const sharesPlaceholder: PlaceholderType = {
  'en-US': 'Share',
  'zh-CN': '分享量',
};

export const channelPlaceholder: PlaceholderType = {
  'en-US': 'Channel',
  'zh-CN': '渠道',
};

export const reviewersPlaceholder: PlaceholderType = {
  'en-US': 'Reviewer',
  'zh-CN': '发帖人',
};

export const dataSourcePlaceholder: PlaceholderType = {
  'en-US': 'Data Source',
  'zh-CN': '数据源',
};

export const heroPlaceholder: PlaceholderType = {
  'en-US': 'Hero',
  'zh-CN': '英雄',
};

export const NIKKEPlaceholder: PlaceholderType = {
  'en-US': 'Nikke',
  'zh-CN': '角色',
};

export const invalidPlaceholder: PlaceholderType = {
  'en-US': 'Validation Filter',
  'zh-CN': '评论有效性',
};

export const recordTimePlaceholder: PlaceholderType = {
  'en-US': 'Record Time',
  'zh-CN': '总游玩时长',
};

export const reviewTimePlaceholder: PlaceholderType = {
  'en-US': 'Review Time',
  'zh-CN': '评论时游玩时长',
};

export const refundedPlaceholder: PlaceholderType = {
  'en-US': 'Refunded',
  'zh-CN': '退款',
};

export const starredTagPlaceholder: PlaceholderType = {
  'en-US': 'Starred Tag',
  'zh-CN': '星标',
};

export const freePlayedPlaceholder: PlaceholderType = {
  'en-US': 'Free Played',
  'zh-CN': '免费游玩',
};

export const steamPurchasePlaceholder: PlaceholderType = {
  'en-US': 'Steam Purchase',
  'zh-CN': 'Steam购买',
};

export const aigcPlaceholder: PlaceholderType = {
  'en-US': 'AI Generated',
  'zh-CN': 'AI生成',
};

export const keywordFilterTypePlaceholder: PlaceholderType = {
  'en-US': 'Keywords Type',
  'zh-CN': '关键词来源',
};

export const gameTypePlaceholder: PlaceholderType = {
  'en-US': 'Game Type',
  'zh-CN': '游戏类型',
};

export const channelTypePlaceholder: PlaceholderType = {
  'en-US': 'Channel Type',
  'zh-CN': '渠道类型',
};

export const influencersTypePlaceholder: PlaceholderType = {
  'en-US': 'Influencers Type',
  'zh-CN': '网红类型',
};

export const matchedTypePlaceholder: PlaceholderType = {
  'en-US': 'Matched Type',
  'zh-CN': '匹配方式',
};

export const PerspectivePlaceholder: PlaceholderType = {
  'en-US': 'Perspective',
  'zh-CN': '视角',
};

export const languagePlaceholder: PlaceholderType = {
  'en-US': 'Language',
  'zh-CN': '语种',
};

export const UVPMPlaceholder: PlaceholderType = {
  'en-US': 'Reach',
  'zh-CN': '曝光量',
};

export const newsDataSourcePlaceholder: PlaceholderType = {
  'en-US': 'Data Source',
  'zh-CN': '数据源',
};

export const typeOfCoveragePlaceholder: PlaceholderType = {
  'en-US': 'Type of Coverage',
  'zh-CN': '报道类型',
};

export const newsBatePlaceholder: PlaceholderType = {
  'en-US': 'Beat',
  'zh-CN': '新闻口',
};

export const monitorPlaceholder: PlaceholderType = {
  'en-US': 'Monitor Method',
  'zh-CN': '监控方式',
};

export const platformPlaceholder: PlaceholderType = {
  'en-US': 'Platform',
  'zh-CN': '平台',
};

export const ratingPlaceholder: PlaceholderType = {
  'en-US': 'Ratings',
  'zh-CN': '商店评分',
};

export const sentimentPlaceholder: PlaceholderType = {
  'en-US': 'Sentiment',
  'zh-CN': '整句情感分',
};

export const topicSentimentPlaceholder: PlaceholderType = {
  'en-US': 'Topic Sentiment',
  'zh-CN': '话题情感分',
};

export const sentimentClausePlaceholder: PlaceholderType = {
  'en-US': 'Sub Sentiment',
  'zh-CN': '子句情感分',
};

export const videoTypePlaceholder: PlaceholderType = {
  'en-US': 'Video Type',
  'zh-CN': '视频类型',
};

export const versionPlaceholder: PlaceholderType = {
  'en-US': 'Patch/Version',
  'zh-CN': '版本',
};

export const versionTimePlaceholder: PlaceholderType = {
  'en-US': 'Period',
  'zh-CN': '周期',
};

export const topicPlaceholder: PlaceholderType = {
  'en-US': 'Topic',
  'zh-CN': '话题',
};

export const regionPlaceholder: PlaceholderType = {
  'en-US': 'Region',
  'zh-CN': '区域',
};

export const accountRegionPlaceholder: PlaceholderType = {
  'en-US': 'Account Region',
  'zh-CN': '账号区域',
};

export const monitorSourcePlaceholder: PlaceholderType = {
  'en-US': 'Opencritic/Metacritic Review Type',
  'zh-CN': 'Opencritic/Metacritic 评论类型',
};

export const reviewsTypePlaceholder: PlaceholderType = {
  'en-US': 'Review Type',
  'zh-CN': '评论类型',
};

export const productPlaceholder: PlaceholderType = {
  'en-US': 'Product',
  'zh-CN': '产品',
};

export const sentimentEditingStatusPlaceholder: PlaceholderType = {
  'en-US': 'Sentiment Editing Status',
  'zh-CN': '情感分编辑状态',
};

export const reviewerTypePlaceholder: PlaceholderType = {
  'en-US': 'Reviewer Type',
  'zh-CN': '发帖人类型',
};

export const liveVenuesPlaceholder: PlaceholderType = {
  'en-US': 'Stream Sessions',
  'zh-CN': '直播场次',
};

export const gamePlaceholder: PlaceholderType = {
  'en-US': 'Game',
  'zh-CN': '游戏',
};

export const genreGamePlaceholder: PlaceholderType = {
  'en-US': 'Games Covered',
  'zh-CN': '涵盖游戏',
};

export const competitorGamePlaceholder: PlaceholderType = {
  'en-US': 'Competitor',
  'zh-CN': '竞品游戏',
};

export const genrePlaceholder: PlaceholderType = {
  'en-US': 'Genre',
  'zh-CN': '品类',
};

export const hashtagPlaceholder: PlaceholderType = {
  'en-US': 'Hashtag',
  'zh-CN': 'Hashtag',
};

export const keyKolPlaceholder: PlaceholderType = {
  'en-US': 'Key KOL',
  'zh-CN': '核心KOL',
};

export const videoTagPlaceholder: PlaceholderType = {
  'en-US': 'Video Tag',
  'zh-CN': '视频标签',
};

export const followerRangePlaceholder: PlaceholderType = {
  'en-US': 'Follower Range',
  'zh-CN': '粉丝量范围',
};

export const keyWordsPlaceholder: PlaceholderType = {
  'en-US': 'Keyword',
  'zh-CN': '关键字',
};

export const steamIdPlaceholder: PlaceholderType = {
  'en-US': 'Steam ID',
  'zh-CN': 'Steam ID',
};

export const earlyAccessPlaceholder: PlaceholderType = {
  'en-US': 'Early Access Reviews',
  'zh-CN': '早期体验',
};

export const commentsUnderThePostContainingKeywordsIncludedPlaceholder: PlaceholderType =
  {
    'en-US': 'Include comments under the main post containing keywords',
    'zh-CN': '是否包含命中关键词的主贴下的评论',
  };

export const funnyPlaceholder: PlaceholderType = {
  'en-US': 'Funny',
  'zh-CN': '觉得有趣',
};

export const helpfulPlaceholder: PlaceholderType = {
  'en-US': 'Helpful',
  'zh-CN': '觉得有用',
};

export const gameAffinityPlaceholder: PlaceholderType = {
  'en-US': 'Game Affinity',
  'zh-CN': '游戏亲密度',
};

export const brandAffinityPlaceholder: PlaceholderType = {
  'en-US': 'Brand Affinity',
  'zh-CN': '品牌亲密度',
};

export const totalPublicationsPlaceholder: PlaceholderType = {
  'en-US': 'Total Publications',
  'zh-CN': '总发帖量',
};

export const avgViewsPlaceholder: PlaceholderType = {
  'en-US': 'Avg Views',
  'zh-CN': '平均观看量',
};

export const viewsPlaceholder: PlaceholderType = {
  'en-US': 'Views',
  'zh-CN': '观看量',
};

export const avgEngagementRatePlaceholder: PlaceholderType = {
  'en-US': 'Avg Engagement Rate',
  'zh-CN': '平均互动量',
};

export const brandRelatedPublicationsPlaceholder: PlaceholderType = {
  'en-US': 'Brand-Related Publications',
  'zh-CN': '品牌游戏发帖量',
};

export const brandRelatedAvgViewsPlaceholder: PlaceholderType = {
  'en-US': 'Brand-Related Avg Views',
  'zh-CN': '品牌游戏平均观看量',
};

export const datePlaceholder: PlaceholderType = {
  'en-US': 'Date',
  'zh-CN': '时间',
};

export const dateTypePlaceholder: PlaceholderType = {
  'en-US': 'Date Type',
  'zh-CN': '时间类型',
};

export const urlAnalysisPlaceholder: PlaceholderType = {
  'en-US': 'Video&Post URL Analysis',
  'zh-CN': '视频/图文贴URL分析',
};

export const intentPlaceholder: PlaceholderType = {
  'en-US': 'Intent',
  'zh-CN': '意图',
};

export const postStreamTypePlaceholder: PlaceholderType = {
  'en-US': 'Post/Stream Count',
  'zh-CN': '发帖量/直播场数',
};

export const postAuthorTypePlaceholder: PlaceholderType = {
  'en-US': 'Post Author Type',
  'zh-CN': '发帖人类型',
};

export const xboxEditionTypePlaceholder: PlaceholderType = {
  'en-US': 'Edition',
  'zh-CN': '版本',
};

export const videoAITagPlaceholder: PlaceholderType = {
  'en-US': 'AI Tag',
  'zh-CN': 'AI标签',
};

export const dateTypeMap: any = {
  hourly: { 'en-US': 'By Hour', 'zh-CN': '按小时' },
  daily: { 'en-US': 'By Day', 'zh-CN': '按日' },
  weekly: { 'en-US': 'By Week', 'zh-CN': '按周' },
  monthly: { 'en-US': 'By Month', 'zh-CN': '按月' },
  year: { 'en-US': 'By Year', 'zh-CN': '按年' },
};

export const zoneGamesPlaceholder: Record<string, string> = {
  'en-US': 'Games',
  'zh-CN': '游戏',
};

export const blackGrayAuthorPlaceholder: PlaceholderType = {
  'en-US': 'Grey Underworld Influencers',
  'zh-CN': '黑灰产网红',
};

export const placeholderMap: {
  [key in FilterKeys | 'accountRegion' | 'dateType']?: PlaceholderType;
} = {
  channel: channelPlaceholder,
  hero: heroPlaceholder,
  NIKKE: NIKKEPlaceholder,
  invalid: invalidPlaceholder,
  refunded: refundedPlaceholder,
  starredTag: starredTagPlaceholder,
  freePlayed: freePlayedPlaceholder,
  steamPurchase: steamPurchasePlaceholder,
  recordTimes: recordTimePlaceholder,
  reviewTimes: reviewTimePlaceholder,
  language: languagePlaceholder,
  monitor: monitorPlaceholder,
  platform: platformPlaceholder,
  rating: ratingPlaceholder,
  steamRating: ratingPlaceholder,
  topic: topicPlaceholder,
  sentiment: sentimentPlaceholder,
  version: versionPlaceholder,
  region: regionPlaceholder,
  accountRegion: accountRegionPlaceholder,
  hashtag: hashtagPlaceholder,
  monitorSource: monitorSourcePlaceholder,
  followerRange: followerRangePlaceholder,
  keyWords: keyWordsPlaceholder,
  videoTag: videoTagPlaceholder,
  engagementPerformance: engagementPerformancePlaceholder,
  engagementsRange: engagementsPlaceholder,
  commentsRange: commentsPlaceholder,
  likesRange: likesPlaceholder,
  sharesRange: sharesPlaceholder,
  reviewType: reviewsTypePlaceholder,
  matchedType: matchedTypePlaceholder,
  reviewers: reviewersPlaceholder,
  steamIds: steamIdPlaceholder,
  earlyAccess: earlyAccessPlaceholder,
  funnys: funnyPlaceholder,
  helpfuls: helpfulPlaceholder,
  sentimentClause: sentimentClausePlaceholder,
  keywordFilterType: keywordFilterTypePlaceholder,
  liveVenues: liveVenuesPlaceholder,
  influencersType: influencersTypePlaceholder,
  brandAffinitys: brandAffinityPlaceholder,
  totalPublications: totalPublicationsPlaceholder,
  avgViews: avgViewsPlaceholder,
  views: viewsPlaceholder,
  avgEngagementRate: avgEngagementRatePlaceholder,
  brandRelatedPublications: brandRelatedPublicationsPlaceholder,
  brandRelatedAvgViews: brandRelatedAvgViewsPlaceholder,
  genreGameList: genreGamePlaceholder,
  gameAffinitys: gameAffinityPlaceholder,
  channelType: channelTypePlaceholder,
  channelTypeSingle: channelTypePlaceholder,
  perspective: PerspectivePlaceholder,
  dataSource: dataSourcePlaceholder,
  gameType: gameTypePlaceholder,
  date: datePlaceholder,
  genre: genrePlaceholder,
  game: gamePlaceholder,
  versionTime: versionTimePlaceholder,
  dateType: dateTypePlaceholder,
  newsBate: newsBatePlaceholder,
  newsCoverageType: typeOfCoveragePlaceholder,
  newsUVPM: UVPMPlaceholder,
  newsDataSource: newsDataSourcePlaceholder,
  competitorGames: competitorGamePlaceholder,
  kolTags: reviewerTypePlaceholder,
  videoType: videoTypePlaceholder,
  urlAnalysis: urlAnalysisPlaceholder,
  subTopicSentiment: topicSentimentPlaceholder,
  keyKol: keyKolPlaceholder,
  postStream: postStreamTypePlaceholder,
  postAuthorType: postAuthorTypePlaceholder,
  xboxEdition: xboxEditionTypePlaceholder,
  commentsUnderThePostContainingKeywordsIncluded:
    commentsUnderThePostContainingKeywordsIncludedPlaceholder,
  zoneGames: zoneGamesPlaceholder,
  blackGrayAuthor: blackGrayAuthorPlaceholder,
  aigc: aigcPlaceholder,
};

export function getPlaceholderText(
  key: FilterKeys | 'accountRegion',
  lang: LocaleType = getLocale(),
) {
  return placeholderMap[key]?.[lang];
}
